import { render, staticRenderFns } from "./RoleHoverCard.vue?vue&type=template&id=9e7385c4&scoped=true"
import script from "./RoleHoverCard.vue?vue&type=script&lang=js"
export * from "./RoleHoverCard.vue?vue&type=script&lang=js"
import style0 from "./RoleHoverCard.vue?vue&type=style&index=0&id=9e7385c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e7385c4",
  null
  
)

export default component.exports